import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    //const carId = this.element.getAttribute("data-car-id");
    //const source = this.element.getAttribute("data-source");
    //this.form = document.getElementById(`c-lead-form-${carId}-${source}`);
    //console.log(this.form);
    let _this = this;
    _this.leadSubmit = this.element.querySelector(".lead-submit");
    _this.tos = document.getElementsByClassName('c-checkbox__tos');

    _this.tos.forEach((item)=> {
      console.log(item);
      item.addEventListener('change', function(e){
        if (item.checked  ){
          _this.leadSubmit.disabled = null;
        } else {
          _this.leadSubmit.disabled = "disabled";
        }
      });
    });
  }

  showModal() {
    const carId = this.element.getAttribute("data-car-id");
    const elem = document.getElementById(`car-lead-form-${carId}`);
    elem.style.display = 'block';
  }

  closeModal() {
    const carId = this.element.getAttribute("data-car-id");
    const elem = document.getElementById(`car-lead-form-${carId}`);
    elem.style.display = 'none';
    this.leadSubmit.disabled = 'disabled'
  }

  redirect() {
    window.location.href = "/leads/success"
  }
}